/* eslint-disable */

/**
 * @param {function} callback
 * @param {number} delay
 * @returns {function}
 */
function throttle(callback, delay) {
    let isThrottled = false;
    let args = null;
    let context = null;

    /** */
    function wrapper() {
        if (isThrottled) {
            args = arguments;
            context = this;
            return;
        }

        isThrottled = true;
        callback.apply(this, arguments);

        setTimeout(() => {
            isThrottled = false;
            if (args) {
                wrapper.apply(context, args);
                args = null;
                context = null;
            }
        }, delay);
    }

    return wrapper;
}

export default throttle;
